export default __webpack_public_path__ + "static/media/pantry2-before1-1024w.06df5eaf.webp";